import React from 'react';

import { Root } from './InlineGroup.styles';

import { InlineGroupProps } from '.';

export const InlineGroup: React.FC<InlineGroupProps> = ({
  children,
  vertical,
  horizontal,
  childGap,
  fullWidth = false,
  className,
}) => {
  return (
    <Root
      vertical={vertical}
      horizontal={horizontal}
      childGap={childGap}
      fullWidth={fullWidth}
      className={className}
    >
      {children}
    </Root>
  );
};
